import { validateCallback } from "../validateCallback";
var ScreenOrientation = Object.freeze({
  getOrientation: function getOrientation() {
    return Promise.resolve("unknown");
  },
  lock: function lock(_orientation) {
    return Promise.resolve("unknown");
  },
  unlock: function unlock() {
    return Promise.resolve("unknown");
  },
  addChangeListener: function addChangeListener(onChange) {
    validateCallback(onChange, "ScreenOrientation.addChangeListener requires a function");
    return function() {
    };
  }
});
export {
  ScreenOrientation
};
//# sourceMappingURL=unavailable.js.map
